module.exports = __webpack_public_path__ + "img/012陈希萌.f44a26af.png";